import queryString from 'query-string';

import AppEnvironment from 'helpers/AppEnvironment';
import logger from 'middleware/logger';

export function extractEmailAuthToken(routing) {
  const { search } = routing && routing.locationBeforeTransitions || {};
  const { auth_token: emailAuthToken } = queryString.parse(search) || {};
  return emailAuthToken;
}

/**
 * Returns whether there is an email auth token present.
 *
 * @param {*} param0
 */
export function isEmailAuthTokenPresent({ getState }) {
  const { routing } = getState();
  return !!extractEmailAuthToken(routing);
}

/**
 * Returns whether the current user has the possibility of being authenticated.  This means that the user has both a x-main and at-main cookie.
 *
 * However there is still the possiblity that the user will be prompted to re-authenticate for a given service.
 * Do not use this on the client as it'll always say you're not authenticated.
 * @param {*} param0
 */
export function isMaybeAuthenticated({ getState }) {
  const { cookies } = getState();
  if (AppEnvironment.isClient) {
    logger.error('isMaybeAuthenticated should not be used client side.');
  }
  return (!!(cookies['x-main'] && cookies['at-main'])) || isEmailAuthTokenPresent({ getState });
}
